(function () {
  'use strict';

  /* ---------------- Mobile nav toggle ---------------- */
  var mobileToggle = document.getElementById('MobileNavToggle');
  var mobileNav = document.getElementById('MobileNav');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ---------------- Mega menu (click/touch toggle, hover still works via CSS) ---------------- */
  var megaTriggers = document.querySelectorAll('.mega-trigger');
  megaTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      var navItem = trigger.closest('.nav-item');
      if (!navItem) return;
      // Only intercept on touch/mobile widths; on desktop, hover handles it and the link should still work.
      if (window.matchMedia('(max-width: 860px)').matches) {
        e.preventDefault();
        var isOpen = navItem.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    });
  });

  document.addEventListener('click', function (e) {
    document.querySelectorAll('.nav-item.is-open').forEach(function (item) {
      if (!item.contains(e.target)) {
        item.classList.remove('is-open');
        var trigger = item.querySelector('.mega-trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.nav-item.is-open').forEach(function (item) {
        item.classList.remove('is-open');
      });
      closeCartDrawer();
    }
  });

  /* ---------------- Cart drawer open/close ---------------- */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartLink = document.getElementById('CartLink');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  if (cartLink && cartDrawer) {
    cartLink.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  /* ---------------- AJAX cart helpers ---------------- */
  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    var el = document.getElementById('CartCount');
    if (el) el.textContent = count;
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  function renderCartDrawer(cart) {
    var itemsEl = document.getElementById('CartDrawerItems');
    var subtotalEl = document.getElementById('CartDrawerSubtotal');
    if (!itemsEl) return;

    updateCartCount(cart.item_count);
    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer-empty">Your bag is empty.</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item, index) {
      var image = item.image ? '<img src="' + item.image + '&width=160" alt="">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-item-variant">' + item.variant_title + '</div>'
        : '';
      return (
        '<div class="cart-drawer-line" data-key="' + item.key + '">' +
          image +
          '<div class="cart-drawer-line-info">' +
            '<span class="name">' + item.product_title + '</span>' +
            variant +
            '<div class="cart-drawer-line-controls">' +
              '<input type="number" min="0" value="' + item.quantity + '" data-cart-qty data-key="' + item.key + '" aria-label="Quantity">' +
              '<span>' + moneyFormat(item.final_line_price) + '</span>' +
              '<button type="button" data-cart-remove data-key="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    itemsEl.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        changeCartLine(input.dataset.key, input.value);
      });
    });
    itemsEl.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeCartLine(btn.dataset.key, 0);
      });
    });
  }

  function changeCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  /* ---------------- Add to cart (product form) ---------------- */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var submitBtn = productForm.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          var message = productForm.querySelector('[data-add-to-cart-message]');
          if (message) message.hidden = false;
          openCartDrawer();
        })
        .catch(function () {})
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  /* ---------------- Variant picker: map option selects to a variant id ---------------- */
  var variantsDataEl = document.getElementById('ProductVariantsData');
  var variantIdInput = document.getElementById('ProductVariantId');
  var optionSelects = document.querySelectorAll('.product-option-select');

  if (variantsDataEl && variantIdInput && optionSelects.length) {
    var variants = JSON.parse(variantsDataEl.textContent);

    function currentSelection() {
      var values = [];
      optionSelects.forEach(function (select) {
        values[parseInt(select.dataset.optionPosition, 10) - 1] = select.value;
      });
      return values;
    }

    function findMatchingVariant() {
      var selection = currentSelection();
      return variants.find(function (variant) {
        return selection.every(function (value, index) {
          return variant['option' + (index + 1)] === value;
        });
      });
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        var match = findMatchingVariant();
        if (match) {
          variantIdInput.value = match.id;
          var priceEl = document.querySelector('.product-detail-price');
          if (priceEl) priceEl.textContent = moneyFormat(match.price);
          var addBtn = document.querySelector('.product-detail-add');
          if (addBtn) {
            addBtn.disabled = !match.available;
            addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
          }
        }
      });
    });
  }

  /* ---------------- Cart page: quantity + remove ---------------- */
  document.querySelectorAll('.cart-qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      updateCartLineByPosition(input.dataset.line, input.value);
    });
  });
  document.querySelectorAll('.cart-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      updateCartLineByPosition(btn.dataset.line, 0);
    });
  });

  function updateCartLineByPosition(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () {
      window.location.reload();
    });
  }
})();
